import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../theming/useTheme';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { LARGE_SCREEN_SIZE } from '../../../mediaQueries.const';

const createStyles = (baseUnit: BaseUnit) => StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: `${LARGE_SCREEN_SIZE}px`,
    margin: '0 auto',
    marginTop: `${baseUnit}px`,
  },
});


interface ButtonWrapperComponentThemeProps {
  baseUnit: BaseUnit;
}

export const LoadMoreButtonWrapperComponent: React.FunctionComponent<ButtonWrapperComponentThemeProps> = ({ baseUnit, children }) => {
  const style = createStyles(baseUnit);

  return (
    <div className={css(style.container)}>
      {children}
    </div>
  );
};

const mapThemeProps = (theme: ButtonWrapperComponentThemeProps) => ({
  baseUnit: theme.baseUnit,
});

export const LoadMoreButtonWrapper: React.FunctionComponent = (props: {}) => {
  const themeContext = useTheme(mapThemeProps);
  return <LoadMoreButtonWrapperComponent {...themeContext} {...props} />;
};
